import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { Heroimage } from '../../components'
import { Backtotop } from '../../widgets'
import { Information, Founder, Companies, Events, Paralax, News } from '../../containers'
import { events } from "../../constants/events";
import { VideoWidget } from '../../components';
import './Home.css';




const clgpic = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Homepage_pics/clgpicfinal.webp"
const clgvdo = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Homepage_pics/R.M+Alagappa+Chettiar.mp4"

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'ACCET-Karaikudi | Alagappa Chettiar Government College of Engineering and Technology';
  }, []);
  return (
    <>
      <Heroimage image={clgpic} alternate="College" />
      <div
        className="platinum-jubilee-text"
        onClick={() => navigate("/alumni-landing")}
      >
        Platinum Jubilee Celebration
      </div>

      <Information />



      <Founder />

      <div className='home_clg_vdo_holder'>
        <video className='home_clg_vdo' controls autoPlay muted>
          <source src={clgvdo} type="video/mp4" />
        </video>
      </div>

      <News />
      {/* <Input type="date" required /> */}

      <Paralax />

      <Companies />

      <Events events={events} head="Events" />

      <Backtotop />
      {/* <VideoWidget /> */}

    </>
  )
}

export default Home;